import { create } from "zustand";
import { TReceiptCustomisationStore } from "./types";
import { DateAndTimeConfigForReceipt } from "@elixir/types";

const useReceiptCustomisationStore = create<TReceiptCustomisationStore>(
  (set, get) => ({
    hasChanged: false,

    clinicId: "",
    setClinicId: ({ clinicId }) => set({ clinicId }),

    selectedDoctorId: "",
    setSelectedDoctorId: ({ doctorId }) => set({ selectedDoctorId: doctorId }),

    header: {
      showHeader: true,
      headerHeight: 1,
    },
    setHeader: (newHeader) => {
      set({ header: newHeader, hasChanged: true });
    },

    footer: {
      showFooter: true,
      footerHeight: 1.5,
    },
    setFooter: (newFooter) => {
      set({ footer: newFooter, hasChanged: true });
    },

    margin: {
      top: 1,
      left: 1,
      right: 1,
      bottom: 1,
    },
    setMargin: (newMargin) => {
      const { margin } = get();
      set({ margin: { ...margin, ...newMargin }, hasChanged: true });
    },

    columns: {
      discount: "ALWAYS",
      quantity: "ALWAYS",
      page_size: "A4",
    },
    setColumns: (selectedColumn) => {
      const { columns } = get();
      const { property, value } = selectedColumn;
      set({ columns: { ...columns, [property]: value }, hasChanged: true });
    },

    others: {
      showUHID: true,
      showPaymentMethod: true,
      showReceiptNumber: true,
      requireUhid: false,
      print_amount_in_words: false,
      date_and_time: DateAndTimeConfigForReceipt.DATE_ONLY,
      bill_created_at: false,
      print_bill_created_by: false,
    },
    setOthers: (newOthers) => {
      set({ others: newOthers, hasChanged: true });
    },

    setReceiptState: (receiptState) => {
      set({ ...receiptState });
    },
  })
);

export default useReceiptCustomisationStore;
